export default {
  nav: {
    base: 1100
  },
  progress: {
    base: 10000
  }
}
